<template>
  <div>
    <el-menu
      :default-openeds="defaultOpenMenus"
      :default-active="$route.path"
      class="user-menu"
      router>
      <el-submenu index="user">
        <template slot="title">
          <span>我的账户</span>
        </template>
        <el-menu-item index="/user/profile">信息维护</el-menu-item>
        <el-menu-item index="/user/update-password">修改密码</el-menu-item>
        <!-- 可下单 -->
        <el-menu-item v-if="!userInfo.canOrder && userInfo.clientType !== '03'" index="/user/address">收货地址</el-menu-item>
        <el-menu-item v-if="!userInfo.canOrder && userInfo.clientType !== '03'" index="/user/invoice">发票信息</el-menu-item>
        <el-menu-item index="/user/order/list">我的订单</el-menu-item>
        <el-menu-item v-if="!userInfo.canOrder" index="/user/coupon/list">我的卡券</el-menu-item>
        <el-menu-item v-if="!userInfo.canOrder" index="/user/ecard/list">多利E卡</el-menu-item>
        <!-- 不可下单 -->
        <el-menu-item v-if="userInfo.subClientIds && userInfo.subClientIds.length" index="/user/distribution-coupon-list">分配卡券</el-menu-item>
        <el-menu-item v-if="userInfo.subClientIds && userInfo.subClientIds.length" index="/user/distribution-history-list">分配历史</el-menu-item>
      </el-submenu>

    </el-menu>
  </div>
</template>

<script>
export default {
  name: 'UserMenu',
  data() {
    return {
      defaultOpenMenus: ['user'],
      userInfo: {
        canOrder: ''
      }
    }
  },
  mounted() {
    this.userInfo = Object.assign({}, this.userInfo, this.$store.getters.userInfo)
  }
}
</script>

<style lang="scss" scoped>
@import '../../../assets/styles/variables.scss';
.user-menu {
  padding: 0 0 30px 0;

  /deep/ .el-submenu__title {
    height: 50px;
    line-height: 50px;
  }
  /deep/ .el-submenu .el-menu-item  {
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    min-width: 160px;
  }
  /deep/ .el-menu-item.is-active {
    color: $base-red
  }
}
</style>
